<template
  ><div>
    <Card style="width:100%;">
      <p slot="title">
        <Icon type="md-keypad" size="22" style="margin-right:10px" />继任者盘点
      </p>
      <div class="cs-tabPane2-tree">
        <Vue2OrgTree
          name="test"
          :data="datas"
          :horizontal="horizontal"
          :label-class-name="labelClassName"
          :render-content="renderContent"
          collapsable
          @on-expand="onExpand"
          @on-node-click="onNodeClick"
        >
        </Vue2OrgTree>
      </div>
      <div style="display: flex;justify-content: space-between;">
        <Form :model="formItem" :label-width="120" inline>
          <FormItem label="中国区继任率">
            <Input type="text" v-model="formItem.code1" />
          </FormItem>
          <FormItem label="Group继任率">
            <Input type="text" v-model="formItem.code1" />
          </FormItem>
        </Form>
        <div>
          <!-- <Button @click="personPage">人才比对</Button> -->
          <Button @click="modal = true">追加空岗</Button>
        </div>
      </div>
    </Card>
    <Modal v-model="modal" title="追加空岗">
      <Form :model="formItem" :label-width="120">
        <FormItem label="业务单元">
          <Select v-model="formItem.code1" style="width:200px">
            <Option v-for="item in list1" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="部门">
          <Select v-model="formItem.code2" style="width:200px">
            <Option v-for="item in list2" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="职位">
          <Select v-model="formItem.code3" style="width:200px">
            <Option  v-for="item in list3" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="Band">
          <Select v-model="formItem.code4" style="width:200px">
            <Option v-for="item in list4" :value="item.value" :key="item.value" >{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem label="人数">
          <Input style="width:200px" type="text" v-model="formItem.code1" />
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      modal: false,
      horizontal: false,
      collapsable: true,
      expandAll: false,
      labelClassName: "bg-none",
      datas: {
        id: "1",
        label: "GM/FH",
        sub: "",
        positionT1: "XXX",
        positionT2: "XXX",
        position: "GM/FH",
        relations: "1",
        children: [
          {
            id: "1-1",
            label: "XXX<Position>",
            sub: "XXX<Staff>L",
            type: "L",
            positionT1: "XXX",
            positionT2: "",
            relations: "1-1"
          },
          {
            id: "1-2",
            label: "XXX<Position>",
            sub: "XXX<Staff>M",
            type: "M",
            positionT1: "",
            positionT2: "XXX",
            relations: "1-2"
          },
          {
            id: "1-3",
            label: "XXX<Position>",
            sub: "XXX<Staff>H",
            type: "H",
            positionT1: "",
            positionT2: "",
            relations: "1-3"
          },
          {
            id: "1-4",
            label: "XXX<Position>",
            sub: "XXX<Staff>L",
            positionT1: "",
            positionT2: "XXX",
            relations: "1-4"
          },
          {
            id: "1-5",
            label: "XXX<Position>",
            sub: "XXX<Staff>L",
            positionT1: "XXX",
            positionT2: "",
            relations: "1-5"
          },
          {
            id: "1-5",
            label: "XXX<Position>",
            sub: "XXX<Staff>L",
            positionT1: "",
            positionT2: "",
            relations: "1-5"
          },
          {
            id: "1-5",
            label: "XXX<Position>",
            sub: "XXX<Staff>L",
            positionT1: "XXX",
            positionT2: "XXX",
            relations: "1-5"
          }
        ]
      },
      formItem: {},
      list1: [],
      list2: [],
      list3: [],
      list4: []
    };
  },
  created() {
    this.getDate();
    this.toggleExpand(this.datas, true);
  },

  methods: {
    getDate() {
      // axios.post("/OrgPositionImg/selectOrgPositionData", {}).then((res) => {
      //     if(res){
      //         this.datas=res
      //         this.toggleExpand(this.datas,true)
      //     }
      // }).catch(err => {
      //     this.$Message.info(err);
      // })
    },
    onExpand(e, data) {
      if ("expand" in data) {
        data.expand = !data.expand;
        if (!data.expand && data.children) {
          this.collapse(data.children);
        }
      } else {
        this.$set(data, "expand", true);
      }
    },
    toggleExpand(data, val) {
      var _this = this;
      if (Array.isArray(data)) {
        data.forEach(function(item) {
          _this.$set(item, "expand", val);
          if (item.children) {
            _this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.children) {
          _this.toggleExpand(data.children, val);
        }
      }
    },
    onNodeClick(e, data) {
      //console.log(data.label);
      if (data.url == null) {
        return false;
      } else {
        window.open(data.url);
      }
    },
    collapse(list) {
      var _this = this;
      list.forEach(function(child) {
        if (child.expand) {
          child.expand = false;
        }
        child.children && _this.collapse(child.children);
      });
    },
    expandChange() {
      this.toggleExpand(this.data, this.expandAll);
    },
    toggleExpand(data, val) {
      var _this = this;
      if (Array.isArray(data)) {
        data.forEach(function(item) {
          _this.$set(item, "expand", val);
          if (item.children) {
            _this.toggleExpand(item.children, val);
          }
        });
      } else {
        this.$set(data, "expand", val);
        if (data.children) {
          _this.toggleExpand(data.children, val);
        }
      }
    },
    initOrg() {
      this.$set(this.datas, "expand", true);
      if (this.datas.children) {
        this.datas.children.forEach((item, index) => {
          this.$set(item, "expand", true);
        });
      }
    },
    goPage(data) {
      console.log(data);
    },
    getTreeClass(data) {
      var str = "";
      str += data.positionT1
        ? "bg-green "
        : data.positionT2
        ? "bg-gold "
        : "bg-tomato ";
      str +=
        data.type == "L"
          ? "fc-green "
          : data.type == "M"
          ? "fc-gold "
          : data.type == "H"
          ? "fc-tomato "
          : "";
      return str;
    },
    renderContent(h, data) {
      return (
        <span
          style="width:100%;height:100%;display:block;padding:6px 10px;border-radius:3px"
          class={this.getTreeClass(data)}
        >
          <dd style="font-size:12px;text-align:center">
            {data.label}
            <p>{data.sub}</p>
          </dd>
          <dd style="font-size:12px;text-align:left">
            <span>T1 {data.positionT1}</span>
            <p>T2 {data.positionT2}</p>
          </dd>
        </span>
      );
    },
    personPage(){
      const href = this.$router.resolve({path:"/090E24C0B112F54BB8C0D94347DD0212/A3FFBEBFDB713E27",query:{}});
      window.open(href,'_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.org-tree-container {
  // display: flex !important;
  // justify-content: center !important;
  overflow-x: auto;
}
.cs-tabPane2-tree {
  height: 60vh;
  display: flex;
  justify-content: center;
  overflow: auto;
}
/deep/ .org-tree-node-label .org-tree-node-label-inner {
  width: auto !important;
}

/deep/.ivu-badge-count {
  top: 0 !important;
  left: -10px !important;
}

.refresh {
  display: flex !important;
  justify-content: flex-end !important;
}

.headerPic {
  img {
    border: 2px solid #f3d367 !important;
  }
}
/deep/.bg-none {
  background-color: #ffffff;
  color: #000000;
}
/deep/.org-boxs {
  width: 100%;
  height: 100%;
  text-align: center;
  /*background: #030C24;*/
  background-image: -webkit-radial-gradient(
    ellipse farthest-corner at center 40%,
    #000d4d 0%,
    #000105 100%
  );
  background-image: radial-gradient(
    ellipse farthest-corner at center 40%,
    #000d4d 0%,
    #000105 100%
  );
  overflow-y: scroll;
}
/deep/.org-tree-container {
  background: none !important;
  padding: 0 !important;
}
/deep/.org-tree-node-label {
  white-space: nowrap;
}
/deep/.bg-white {
  background-color: #ecf5ff;
}
/deep/.org-tree-node-label .org-tree-node-label-inner {
  width: 100px;
  padding: 0px 0px;
  text-align: center;
  border-radius: 6px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
  /* border: 1px solid @colors;*/
  overflow: hidden;
  box-sizing: border-box;
}
/deep/.fc-tomato {
  color: #9e4a1c;
}
/deep/.fc-gold {
  color: #eca150;
}
/deep/.fc-green {
  color: #50cb90;
}
/deep/.bg-tomato {
  border: 2px solid#9E4A1C;
}
/deep/.bg-gold {
  border: 2px solid#ECA150;
}
/deep/.bg-gray {
  border: 2px solid#DECEAA;
}
/deep/.bg-lightpink {
  border: 2px solid#408080;
}
/deep/.bg-blue {
  border: 2px solid#057D9F;
}
/deep/.bg-green {
  border: 2px solid#50CB90;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/teamInfoComponents/tabPane2.vue